import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core';
import styledFuncs from 'app/styles/styledFuncs';
import {
  ListId,
  NameValueListItems,
  TransientPick,
} from 'app/tools/general.types';
import _ from 'lodash';
import React from 'react';
import styled, { css } from 'styled-components/macro';
import Button from '../button/Button';
import Icon from '../icon/Icon';
import IconLib from '../icon/icon-lib';

const ButtonCell = styled(TableCell)``;

type StyledTableOpts = TransientPick<
  Props,
  'noSidePadding' | 'noTopDivider'
>;
const StyledTable = styled(Table)<StyledTableOpts>`
  border-top: 0.5px solid #e8e8e8;
  td {
    padding-top: ${styledFuncs.pad()};
    padding-bottom: ${styledFuncs.pad()};
  }
  td:last-child {
    color: #757575;
  }
  tr:last-child td {
    border-bottom: none;
  }
  ${ButtonCell} {
    padding: ${styledFuncs.pad(0.5)};
  }
  ${p =>
    p.$noSidePadding &&
    css`
      td:first-child {
        padding-left: 0;
      }
      td:last-child {
        padding-right: 0;
      }
    `}
  ${p =>
    p.$noTopDivider &&
    css`
      border-top: none;
    `}
`;

type Props<T extends ListId = ListId> = {
  listItems: NameValueListItems<T>;
  noSidePadding?: boolean;
  noTopDivider?: boolean;
  className?: string;
  onDelete?: (id: T) => unknown;
};

export default function NameValueList<T extends ListId>({
  listItems,
  noSidePadding,
  noTopDivider,
  className,
  onDelete,
}: Props<T>): JSX.Element {
  return (
    <StyledTable
      $noSidePadding={noSidePadding}
      $noTopDivider={noTopDivider}
      {...{ className }}
    >
      <TableBody>
        {_.map(listItems, ({ id, name, value }) => (
          <TableRow key={name}>
            <TableCell>{name}</TableCell>
            <TableCell>{value}</TableCell>
            {onDelete && (
              <ButtonCell>
                <Button
                  iconButton={{ size: 'small' }}
                  onClick={() => onDelete(id)}
                >
                  <Icon icon={IconLib.CROSS} />
                </Button>
              </ButtonCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
}
